import { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import config from '@plone/registry';
import type { ProductsSliderSlide } from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/schema';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/styles.module.css';
import VideoPlayer from '@redturtle/qubicaamf-theme/components/VideoPlayer/VideoPlayer';

interface VideoSlideProps extends Pick<ProductsSliderSlide, 'slide_content'> {
  isActive?: boolean;
}

const VideoSlide = ({ slide_content, isActive }: VideoSlideProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const Image = config.getComponent('Image').component;

  useEffect(() => {
    if (videoRef.current && isActive) {
      videoRef.current.load();
      videoRef.current.play().catch((err) => {
        console.warn('Video play interrupted:', err);
      });
      if (videoRef.current.paused) {
        videoRef.current.play().catch((err) => {
          console.warn('Video play interrupted:', err);
        });
      }
    } else if (videoRef.current) {
      videoRef.current.pause();
    }
  }, [isActive]);

  return (
    <>
      {slide_content.video_file ? (
        <>
          <video
            autoPlay={isActive}
            ref={videoRef}
            preload="none"
            className={cx(styles.video, { [styles.showVideo]: isActive })}
            muted={true}
            loop
            poster={slide_content?.image_scales?.preview_image?.[0]?.download}
          >
            <source src={slide_content.video_file} />
          </video>
          {slide_content.video_file && (
            <Image
              item={slide_content}
              imageField="preview_image"
              className={cx(styles.videoPreviewImage)}
            />
          )}
        </>
      ) : (
        <div className={styles.embeddedVideoContainer}>
          <VideoPlayer
            data={{
              url: slide_content.video_url,
              preview_image: `${slide_content['@id']}/${
                slide_content.image_scales?.image?.[0]?.download ||
                slide_content.image_scales?.preview_image?.[0]?.download
              }`,
            }}
            className={styles.embeddedVideo}
            autoplay={isActive}
          />
        </div>
      )}
    </>
  );
};

export default VideoSlide;
